import { Star } from "lucide-react";

const reviews = [
  {
    name: "Carlos Mendes",
    location: "Juiz de Fora, MG",
    text: "Melhor serviço que já usei. Imagem perfeita em 4K e nunca trava nem nos jogos ao vivo. Suporte responde na hora pelo WhatsApp.",
    img: "https://images.pexels.com/photos/31735315/pexels-photo-31735315.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=150&w=150",
  },
  {
    name: "Fernanda Souza",
    location: "São Paulo, SP",
    text: "Assino o plano anual e vale muito a pena. Tem todos os filmes e séries que eu procuro, catálogo sempre atualizado.",
    img: "https://images.pexels.com/photos/12895422/pexels-photo-12895422.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=150&w=150",
  },
  {
    name: "Roberto Lima",
    location: "Rio de Janeiro, RJ",
    text: "Instalei na Smart TV e no celular em 5 minutos. Funciona perfeitamente nos dois ao mesmo tempo. Recomendo demais!",
    img: null,
  },
];

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="py-24 px-4 sm:px-6">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-14">
        <p className="text-[#FF5A00] text-sm font-bold uppercase tracking-[0.25em] mb-3">Depoimentos</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter" style={{ fontFamily: "Outfit, sans-serif" }}>
          Quem assina, recomenda
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {reviews.map((r, i) => (
          <div
            key={i}
            data-testid={`testimonial-${i}`}
            className="bg-[#0F0F13] border border-white/10 rounded-2xl p-8 hover:-translate-y-1 transition-transform"
          >
            <div className="flex gap-1 mb-4">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} className="w-4 h-4 fill-[#FF5A00] text-[#FF5A00]" />
              ))}
            </div>
            <p className="text-sm text-white/70 leading-relaxed mb-6">"{r.text}"</p>
            <div className="flex items-center gap-3">
              {r.img ? (
                <img src={r.img} alt={r.name} className="w-10 h-10 rounded-full object-cover" loading="lazy" />
              ) : (
                <div className="w-10 h-10 rounded-full bg-[#FF5A00]/20 border border-[#FF5A00]/30 flex items-center justify-center font-bold text-[#FF5A00]">
                  {r.name[0]}
                </div>
              )}
              <div>
                <p className="text-sm font-bold">{r.name}</p>
                <p className="text-xs text-white/45">{r.location}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
